import { SECOND_IN_MILLISECONDS } from 'tracker.constants';

const DELAY_TO_TRY_ANOTHER_QUERY = 30 * SECOND_IN_MILLISECONDS;

export default class Polling {
  constructor(packageId, interval, callbacks) {
    this.packageId = packageId;
    this.interval = interval;
    this.callbackSuccess = callbacks.onSuccess;
    this.callbackQuery = callbacks.onQuery;
    this.timer = null;
  }

  start() {
    if (this.packageId) {
      this.timer = setTimeout(() => {
        this._dataPolling();
        this.start();
      }, this.interval);
    }
  }

  _dataPolling() {
    this.callbackQuery(this.packageId)
      .then(response => this.callbackSuccess(response))
      .catch(error => {
        // eslint-disable-next-line
        console.error(error);
        setTimeout(
          () => this.callbackQuery(this.packageId),
          DELAY_TO_TRY_ANOTHER_QUERY
        );
      });
  }

  stop() {
    clearTimeout(this.timer);
  }
}
